import { useContext } from 'react'
import { TAuthContext } from '../types/Auth'
import { AuthContext } from '../context/AuthContext'

export const useAuthContext = (): TAuthContext => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error(
      'useAuthContext deve ser usado dentro de um StorageProvider'
    )
  }
  return context
}
